module.exports = __webpack_public_path__ + "media/images/shared/ad/muevo_campaign_create_large-e1abf8bd8e5f3f7d1aa185b4d93c09f3.png";